// go-chat-duplication
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { GoCoreChatService } from '@shared/services/gocore/chat/gocore-chat.service';
import { GoActiveChatSessionsService } from '@app/modules/therapist/go-chat/go-active-chat-sessions.service';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';
import { DisplayUserNamePipe } from '../../../../../shared/pipes/display-user-name.pipe';

@Component({
  selector: 'app-go-message-notification-button',
  templateUrl: './go-message-notification-button.component.html',
  styleUrl: './go-message-notification-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatBadge,
    MatProgressSpinner,
    MatMenu,
    MatMenuItem,
    RouterLink,
    AvatarComponent,
    DisplayUserNamePipe,
  ],
})
export class GoMessageNotificationButtonComponent {
  private goActiveChatSessionsService = inject(GoActiveChatSessionsService);
  readonly chatSessions = toSignal(this.goActiveChatSessionsService.activeChatSessions$);
  readonly totalChatNotifications = toSignal(this.goActiveChatSessionsService.totalUnreadMessages$, {
    requireSync: true,
  });

  protected readonly GoCoreChatService = GoCoreChatService;
}
